import React from "react";
import { FileX2 } from "lucide-react";

export function EmptyState({ text = "Nenhum dado disponível para este período.", testId }) {
  return (
    <div
      className="py-12 px-4 text-center bg-slate-50/60 rounded-xl border border-dashed border-slate-200 flex flex-col items-center justify-center space-y-3"
      data-testid={testId || "empty-state"}
    >
      <FileX2 className="h-8 w-8 text-slate-300" />
      <p className="text-sm text-slate-500 font-body">{text}</p>
    </div>
  );
}

const STATUS_MAP = {
  pendente: { label: "Pendente", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  vencido: { label: "Vencido", cls: "bg-rose-50 text-rose-800 border-rose-200" },
  pago: { label: "Pago", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  a_receber: { label: "A Receber", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  recebido: { label: "Recebido", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  cancelado: { label: "Cancelado", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  ativo: { label: "Ativo", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  inativo: { label: "Inativo", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  ativa: { label: "Ativa", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  inativa: { label: "Inativa", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export function StatusBadge({ status, testId }) {
  const s = STATUS_MAP[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${s.cls}`}
      data-testid={testId}
    >
      {s.label}
    </span>
  );
}

export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 animate-fade-in" data-testid={testId}>
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 font-heading">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1 font-body">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
